import { Hero } from '../Components/Hero'
import { PorQueElegirnos } from '../Components/PorQueElegirnos';
import PropuestaValor from '../Components/PropuestaValor';
import Asesoramiento from '../Components/Asesoramiento';
import useSEOConfig from '../../../hooks/seo/useSEOConfig'
import { Navbar } from "../Components/Navbar";
import decorativo from '../../../Assets/img/shape13.svg'
import Formulario from '../Components/Formulario';
import { useConfig } from '../../../context/ConfigContext';

export const APCorporativo = () => {

   const {origen:parametros} = useConfig()
    useSEOConfig(
        {
            title: "Seguros Personales y Profesionales - Asegurá tu tranquilidad",
            description: "Conocé la amplia variedad de seguros que tenemos para vos · Auto · Accidentes Personales · Moto · Hogar · Asistencia al viajero · Mala Praxis · Vida · Celular",
            keywords: "Seguros de Auto, Seguro para moto, Seguros económicos, Cotizar seguro de auto, Seguro Mala praxis, Seguro online, Asistencia al viajero, Aseguradoras, Seguros rivadavia, Seguro flota, Cotizar seguro",
            ogTitle: "Segurarse - Bróker Integral de Seguros digitales",
            ogDescription: "Contratá el seguro que necesitás en pocos pasos. Seguros personales a tu medida al mejor precio. Te asesoramos en todo momento ¡Invertí en tu tranquilidad!",
            twitterCard: "summary_large_image",
        }
    )


    return (
        <>
            <Navbar
                rubro="auto"
            />
            <div style={{ backgroundColor: "white" }}>
                <Hero
                    titulo='Seguro de Accidentes Personales'
                    subTitulo={{ __html: 'Si sos trabajador independiente, te recomendamos que contrates un seguro de accidentes personales para estar cubierto durante tu jornada laboral ante cualquier posible eventualidad.<br /><br />¿Empezamos?' }}
                    icon='#icon-seg-acc-personales'
                    color={parametros!.origen !== "SEGURARSE" ? parametros!.bgColor : undefined}
                    url={parametros!.origen === "SEGURARSE" ? '/cotizador-de-seguros-ap' : '#formulario'}
                />
                <div className={`pt-70 pt-lg-80 pb-40 position-relative ${parametros!.origen === "SEGURARSE" && "bg-primary"}`}
                    style={parametros!.origen !== "SEGURARSE" ? { backgroundColor: parametros!.bgColor } : {}}>
                    <img
                        className="d-none d-lg-block pos16 blend-multipy"
                        src={decorativo}
                        alt="Decorative Shape"
                    />
                    <div className="container">
                        <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-white text-center mb-16 mb-lg-25">
                            ¿Qué cubre?
                        </h2>
                        <div className="col-10 col-lg-12 mx-auto">
                            <p className="fs-17 fs-lg-20 lh-13 text-white text-center mb-16 mb-lg-20">
                                Este tipo de seguro ofrece una compensación financiera para ayudarte a enfrentar los gastos médicos, la pérdida de ingresos, y otros costos asociados con un accidente inesperado. Los planes pueden incluir:
                                <br />
                            </p>
                            <div className="px-20 px-lg-0 maxw-lg-920p mx-auto">
                                <div className="row gx-lg-80">
                                    <div className="col">
                                        <ul className="list-unstyled list-bullet-md fs-16 lh-14 mb-0 text-white">
                                            <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                <b>Indemnización por fallecimiento accidental:</b> proporciona una suma de dinero a los beneficiarios designados, en caso de que el titular del seguro fallezca como resultado de un accidente cubierto.
                                            </li>
                                            <li className="bullet-check-primary ps-35 ps-lg-45 border-bottom border-2 border-white border-opacity-25">
                                                <b>Incapacidad permanente total o parcial:</b> otorga una indemnización en caso de que el asegurado sufra una discapacidad permanente, ya sea total o parcial, debido a un accidente.
                                            </li>
                                            <li className="bullet-check-primary ps-35 ps-lg-45 border-2 border-white border-opacity-25">
                                                <b>Incapacidad temporal:</b> ofrece un beneficio económico si el asegurado queda temporalmente incapacitado para trabajar debido a un accidente. Esta cobertura puede proporcionar pagos periódicos para ayudar a reemplazar la pérdida de ingresos durante el período de recuperación.
                                            </li>
                                            <li className="bullet-check-primary ps-35 ps-lg-45 border-2 border-white border-opacity-25">
                                                <b>Gastos médicos por accidente:</b> cubre los gastos médicos necesarios derivados de un accidente, como honorarios médicos, hospitalización, cirugía, medicamentos, terapias de rehabilitación, y traslados en ambulancia.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {parametros!.origen !== "SEGURARSE" &&
                    <Formulario
                        rubro='AP'
                        titulo='Cotizá seguro de Accidentes Personales'
                        origen={parametros!.origen}
                        color={parametros!.bgColor}
                        extras={parametros!.riesgoData.find(riesgo => riesgo.id === "ap")?.formulario || []}
                    />
                }
                <PorQueElegirnos color={parametros!.bgColor} />
                <PropuestaValor
                    origen={parametros!.origen}
                    color={parametros!.bgColor}
                />
                {parametros!.origen === "SEGURARSE" &&
                    <Asesoramiento />
                }
            </div>
        </>
    )
}